module.exports = require('./src/vue-timepicker.vue')



// WEBPACK FOOTER //
// ./index.js